import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guid: "random",
  quickAssessmentStarted: false,
};

export const quickAssessmentStartedSlice = createSlice({
  name: "quickAssessmentStartedSlice",
  initialState,
  reducers: {
    setQuickAssessmentStarted: (state, action) => {
      state.guid = "radnom";
      state.quickAssessmentStarted = true;
    },
    setQuickAssessmentFinished: (state, action) => {
      state.guid = "radnom";
      state.quickAssessmentStarted = false;
    },
  },
});

export const { setQuickAssessmentStarted, setQuickAssessmentFinished } =
  quickAssessmentStartedSlice.actions;

export const quickAssessmentStartedReducer =
  quickAssessmentStartedSlice.reducer;
